"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFeatureFlags = void 0;
const polaris_client_utils_1 = require("@noths/polaris-client-utils");
const constants_1 = require("./constants");
const parseFeatureFlagsString_1 = require("./parseFeatureFlagsString");
const getFlagsHttpHeaderValue = (req) => {
    const headerValue = req.headers[constants_1.FEATURE_FLAGS_HTTP_HEADER_NAME] || '';
    const headerValueStr = Array.isArray(headerValue)
        ? headerValue.join(constants_1.FLAG_DELIMITER)
        : headerValue;
    return headerValueStr.replaceAll(/, /g, constants_1.FLAG_DELIMITER);
};
const getFeatureFlags = (req, { collapseFlagNames = [] } = {}) => {
    const headerValue = getFlagsHttpHeaderValue(req);
    const allFlags = (0, parseFeatureFlagsString_1.parseFeatureFlagsString)(headerValue);
    const collapseFlags = collapseFlagNames.length > 0;
    if (collapseFlags) {
        return (0, polaris_client_utils_1.cloneObjectWithCollapsingProperties)(allFlags, collapseFlagNames);
    }
    return allFlags;
};
exports.getFeatureFlags = getFeatureFlags;
